// parallax.js
let plaxLeft, plaxUp, plaxCards;

function updatePositions() {
    if (plaxLeft) {
        const plaxLeftTop = plaxLeft.getBoundingClientRect().top;
        if (plaxLeftTop < window.innerHeight) {
            plaxLeft.style.setProperty('--progress', `${plaxLeftTop / 20}px`)

            if(!plaxLeft.style.transform) {
                plaxLeft.style.transform = `translate3d(var(--progress), 0, 0)`;
            }
        }
    }

    if (plaxUp) {
        const plaxUpTop = plaxUp.getBoundingClientRect().top;
        if (plaxUpTop < window.innerHeight) {
            plaxUp.style.setProperty('--progress', `${plaxUpTop / 15}px`)

            if(!plaxUp.style.transform) {
                plaxUp.style.transform = `translate3d(0, calc(-50% + var(--progress)), 0)`;
            }
        }
    }

    if (plaxCards) {
        const plaxCardsTop = plaxCards.getBoundingClientRect().top;
        if (plaxCardsTop < window.innerHeight) {
            const [card1, card2] = plaxCards.querySelectorAll('.card');
            if (card1) {
                card2.style.setProperty('--progress', `${plaxCardsTop / 10}px`)

                if(!card2.style.transform) {
                    card2.style.transform = `translate3d(0, var(--progress), 0)`;
                }
            }
            if (card2) {
                card1.style.setProperty('--progress', `-${plaxCardsTop / 10}px`)

                if(!card1.style.transform) {
                    card1.style.transform = `translate3d(0, var(--progress), 0)`;
                }
            }
        }
    }

    if (plaxLeft || plaxUp || plaxCards) {
        requestAnimationFrame(updatePositions);
    }
}

function observerCallback(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            if ([plaxLeft, plaxUp, plaxCards].includes(entry.target)) {
                requestAnimationFrame(updatePositions);
            }
        }
    });
}

function enableParallax() {
    return window.innerWidth > 1024;
}

export function initializeParallax() {
    const observer = new IntersectionObserver(observerCallback, {
        root: null,
        threshold: 0,
    });

    document.addEventListener('DOMContentLoaded', () => {
        if (!enableParallax()) return;

        plaxLeft = document.querySelector('.plax-title--left');
        plaxUp = document.querySelector('.plax-title--up');
        plaxCards = document.querySelector('.plax-cards');

        if (plaxLeft) observer.observe(plaxLeft);
        if (plaxUp) observer.observe(plaxUp);
        if (plaxCards) observer.observe(plaxCards);
    });

    window.addEventListener('resize', () => {
        if (enableParallax()) {
            if (plaxLeft) observer.observe(plaxLeft);
            if (plaxUp) observer.observe(plaxUp);
            if (plaxCards) observer.observe(plaxCards);
        } else {
            observer.disconnect();
            if (plaxLeft) plaxLeft.style.transform = '';
            if (plaxUp) plaxUp.style.transform = '';
            if (plaxCards) {
                const cards = plaxCards.querySelectorAll('.card');
                cards.forEach(card => (card.style.transform = ''));
            }
        }
    });
}
